export default __webpack_public_path__ + "static/media/background_qed.d58a2449.png";